import React from 'react';
import { RendererContext } from '../../context';

export const useIsConfluenceModule = () => {
	const { extensionType } = React.useContext(RendererContext);
	return extensionType === 'xen:macro' || !!extensionType?.startsWith('confluence');
};
